// extracted by mini-css-extract-plugin
export default {"header":"questionNameHeader_header__dP343"};